const strings = {
  labels: {
    heading: 'Log Outcome',
    taskNotes: 'Call Description',
    callOutcome: 'Call Outcome',
    jobId: 'Job',
    submitButton: 'Log Outcome',
    submitDisabledTooltip:
      'The call must end and outcome must be selected to log the outcome and complete the task.',
    submitDisabledJobIdRequired:
      'A job is required to close with this outcome.',
  },
  placeholders: {
    taskNotes: 'Enter call description...',
    callOutcome: 'Select outcome',
  },
} as const;

export default strings;
